import { DocumentNode } from 'graphql';
import { FC } from 'react';
import { Button, FieldRow, Flex, Modal, WrappedMutation } from '.';

type Props = {
  item?: string;
  itemObject?: { id?: string | undefined };
  refetchQueryObject: any[];
  showModal: boolean;
  closeHandler: () => void;
  deleteMutation: DocumentNode;
  doneHandler: () => void;
  heading?: string;
};

const DeleteItemModal: FC<Props> = props => {
  return (
    <Modal
      open={props.showModal}
      onClose={() => props.closeHandler}
      heading={props.heading ? props.heading : `Delete ${props.item}`}
      body="This cannot be undone."
      actions={
        <WrappedMutation
          mutation={props.deleteMutation}
          awaitRefetchQueries={true}
          refetchQueries={() => props.refetchQueryObject}
          onCompleted={() => props.doneHandler()}
        >
          {(deleteMutation, { loading }) => (
            <FieldRow justifyContent="flex-end">
              <Flex direction="row" size="1" justify="flex-end">
                <Flex direction="row" size="0.5" flexWrap="nowrap">
                  <Button type="button" text="Cancel" mr={3} onClick={() => props.doneHandler()} disabled={loading} />
                  <Button
                    bg="error"
                    type="button"
                    p={0}
                    width="40px"
                    text="Delete"
                    isLoading={loading}
                    disabled={loading}
                    onClick={() => {
                      if (
                        props.itemObject &&
                        props.itemObject.id &&
                        props.itemObject &&
                        !props.itemObject.id.includes('create')
                      ) {
                        deleteMutation({
                          variables: { id: props.itemObject && props.itemObject.id },
                        });
                      } else {
                        props.doneHandler();
                      }
                    }}
                  />
                </Flex>
              </Flex>
            </FieldRow>
          )}
        </WrappedMutation>
      }
    />
  );
};

export default DeleteItemModal;
